import { cn } from "@/common/helpers/utils";

const VEHICLE_WHEEL_CENTER_Y = 47;
export const VEHICLE_GROUND_Y = 54;
export const VEHICLE_HEADLIGHT = { x: 59, y: 42 };

const BODY_PATH =
  "M11 47H7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h3.7l4.2-9.9a3 3 0 0 1 2.8-2.1h16.4a4 4 0 0 1 3.1 1.4l8.4 10.2a1 1 0 0 0 .7.35L52 35a7 7 0 0 1 7 7v3a2 2 0 0 1-2 2h-4M43 47H21";
const WINDOWS_PATH = "M31 35h8.6a.8.8 0 0 0 .6-1.3l-5.3-6.3a1 1 0 0 0-.8-.4H19.6a1 1 0 0 0-.9.6L16 35h10v-8";
const HEADLIGHT_PATH = `M${VEHICLE_HEADLIGHT.x - 2.4} ${VEHICLE_HEADLIGHT.y}H${VEHICLE_HEADLIGHT.x}`;
const REAR_WHEEL_X = 16;
const FRONT_WHEEL_X = 48;
const WHEEL_RADIUS = 5;
const SPOKE_ANGLES = [0, 120, 240] as const;
const SPOKE_LENGTH = 2.6;

export const VEHICLE_SHAPE = {
  bodyPaths: [BODY_PATH, WINDOWS_PATH, HEADLIGHT_PATH],
  wheelXs: [REAR_WHEEL_X, FRONT_WHEEL_X],
  wheelY: VEHICLE_WHEEL_CENTER_Y,
  wheelRadius: WHEEL_RADIUS,
  spokeAngles: SPOKE_ANGLES,
  spokeLength: SPOKE_LENGTH,
} as const;

interface VehicleWheelProps {
  cx: number;
}

function VehicleWheel({ cx }: VehicleWheelProps) {
  const cy = VEHICLE_WHEEL_CENTER_Y;

  return (
    <g className="vehicle-loader-wheel">
      <circle cx={cx} cy={cy} r={WHEEL_RADIUS} strokeWidth={2} />
      {SPOKE_ANGLES.map((angle) => {
        const radians = (angle * Math.PI) / 180;
        return (
          <line
            key={angle}
            x1={cx}
            y1={cy}
            x2={cx + Math.cos(radians) * SPOKE_LENGTH}
            y2={cy + Math.sin(radians) * SPOKE_LENGTH}
            strokeWidth={1.2}
            className="vehicle-loader-spoke"
          />
        );
      })}
    </g>
  );
}

interface VehicleOutlineProps {
  className?: string;
}

export function VehicleOutline({ className }: VehicleOutlineProps) {
  return (
    <g
      className={cn("vehicle-loader-car stroke-primary fill-none", className)}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g className="vehicle-loader-body">
        <path d={BODY_PATH} strokeWidth={2} />
        <path d={WINDOWS_PATH} strokeWidth={2} />
        <path d={HEADLIGHT_PATH} strokeWidth={2} className="vehicle-loader-headlight" />
      </g>
      <VehicleWheel cx={REAR_WHEEL_X} />
      <VehicleWheel cx={FRONT_WHEEL_X} />
    </g>
  );
}
